import {
  DELETE_CARD_FAILED,
  DELETE_CARD_SUCCESS,
  DELETE_CARD_INVALID_REQUEST,
  RESET_DELETE_CARD,
  LOADING_DELETE_CARD
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DELETE_CARD:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
        data: {}
      };
    case DELETE_CARD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload
      };
    case DELETE_CARD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload
      };

    case DELETE_CARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload
      };

    case RESET_DELETE_CARD:
      return (state = initialState);

    default:
      return state;
  }
};
